<template>
  <v-card v-if="this.category!=null">
    <v-card-title
      class="justify-space-between">
      Datasheet for {{ this.category.classification.nameClassification }} with {{ this.category.nameCategory }}.
    </v-card-title>
    <v-card-text>
      To reference material from the datasheets please cite the appropriate volume in Atmospheric Chemistry and Physics from the list <a target="_blank" href="http://www.atmos-chem-phys.net/special_issue8.html">here</a>.
      A zip file containing all of the PDF format datasheets for this category is available : <a :href="$prodPrefix+'datasheets/zipfiles/iupac_'+this.category.codeCategory+'.zip'" download>iupac_{{ this.category.codeCategory }}.zip</a>. Please do not redistribute these datasheets or zipfile. They are for personal use only.
    </v-card-text>
    <slot></slot>
  </v-card>
  <v-card  v-else>
    <v-card-title
      class="justify-space-between">
      Datasheet for {{ this.classification.nameClassification }}.
    </v-card-title>
    <v-card-text>
      To reference material from the datasheets please cite the appropriate volume in Atmospheric Chemistry and Physics from the list <a target="_blank" href="http://www.atmos-chem-phys.net/special_issue8.html">here</a>.
    </v-card-text>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  components: {},
  name: 'HeaderDatasheetsOverview',

  props: ['classification', "category"],
}
</script>

<style scoped>
</style>
